import { render, staticRenderFns } from "./JoinSelectType.vue?vue&type=template&id=5fca2d1e&scoped=true"
import script from "./JoinSelectType.vue?vue&type=script&lang=js"
export * from "./JoinSelectType.vue?vue&type=script&lang=js"
import style0 from "./JoinSelectType.vue?vue&type=style&index=0&id=5fca2d1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca2d1e",
  null
  
)

export default component.exports